/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { IN_RI_CONCEPTS } from '@core/constants';
import { CollectionNoticeModel, CollectionNoticeStatus } from '@core/models';

export function validateItemSelectable(
  item: CollectionNoticeModel,
  allItems: CollectionNoticeModel[]
): boolean {
  if (item.ignoreOrderToPay) {
    return true;
  }

  if (item.orderToPay) {
    const hasPendingPayments = allItems.filter(
      (cn) =>
        item.academicYear?.id === cn.academicYear?.id &&
        item.isExpectedCrm === 1 &&
        !cn.isSelected &&
        item.id !== cn.id
    );
    if (hasPendingPayments.length) {
      return false;
    }
    const olderItems = allItems.filter(
      (n) =>
        n.orderToPay !== null &&
        n.orderToPay < item.orderToPay &&
        n.status.toLowerCase() !== CollectionNoticeStatus.PAID &&
        !n.isSelected
    );

    return !(olderItems.length > 0);
  }

  if (item.isSplit && item.splitNumber) {
    const firstPayment = allItems.find(
      (n) =>
        n.reference === item.legacyReference &&
        n.concept.conceptCategory.id === item.concept.conceptCategory.id
    );

    if (!firstPayment) {
      return false;
    }
    return (
      firstPayment.isSelected ||
      firstPayment.status.toLowerCase() === CollectionNoticeStatus.PAID
    );
  }

  if (
    item.academicYear &&
    item.academicYear.isNext === 1 &&
    item.orderToPay > 20000
  ) {
    const hasPreviousCycleItemsSelected = allItems.some(
      (n) => n.academicYear.isNext !== 1 && n.isSelected
    );
    if (!hasPreviousCycleItemsSelected) {
      return false;
    }
  }

  const previousNotPaid = allItems.find(
    (n) =>
      n.orderToPay < item.orderToPay &&
      !n.isSelected &&
      n.status.toLowerCase() !== CollectionNoticeStatus.PAID
  );
  if (previousNotPaid) {
    return false;
  }

  return true;
}

export function isINorRIConcept(
  collectionNotice: CollectionNoticeModel
): boolean {
  return IN_RI_CONCEPTS.map((conceptCategory) =>
    Object.values(conceptCategory).join()
  ).includes(collectionNotice.concept.conceptCategory.id);
}
